// extracted by mini-css-extract-plugin
export default {"header":"blogSection_header__-cljV","main":"blogSection_main__g-XfV","card":"blogSection_card__q1VEX"};